export const setEvidonLang = (lang: string) => {
    try {
        //May need to check or wait for existence of evidon global object
        window.evidon.notice.activateTranslations(lang);
    } catch (e) {
        console.error('----------------  Error loading spanish translations');
    }
};
